module.exports = __webpack_public_path__ + "static/media/green13.767584bd.jpg";